import { IComboBox, IComboBoxOption, Panel, PanelType, TextField } from "@fluentui/react"
import React, { useCallback } from "react";
import { IEmpresa } from "../../../../interfaces/IEmpresa";
import { IOpenPanel } from "../../../../interfaces/base/IPanel";
import { UseActualizarEmpresa } from "./UseActualizarEmpresa";
import { PanelHeader } from "../../../../components/PanelHeader/PanelHeader";
import { PanelFooter } from "../../../../components/PanelFooter/PanelFooter";
import { MessageBarResponse } from "../../../../components/MessageBar/MessageBarResponse";
import { ProgressBarLoading } from "../../../../components/ProgressBarLoading/ProgressBarLoading";
import { ComboBoxBase } from "../../../../components/comboBoxComponent/ComboBoxBase";
import { UseComboOpciones } from "./UseComboOpciones";

export interface IPanelEmpresaEditar extends IOpenPanel {
    empresaData: IEmpresa
}

export const ActualizarEmpresa = (props: IPanelEmpresaEditar) => {
    const { command, setCommand, putEditarEmpresa, loading, reset, mensaje, status, disableForm, buttonSalir } = UseActualizarEmpresa(props);
    const {
        dataComboOpciones: dataComboTitular,
        onClickComboOpciones: onClickComboTitular,
        _onkeyUpSearchOpciones: _onkeyUpSearchTitular,
        comboBoxRefOpciones: comboBoxRefTitular
    } = UseComboOpciones(props.isOpen); const {
        dataComboOpciones: dataComboTransporte,
        onClickComboOpciones: onClickComboTransporte,
        _onkeyUpSearchOpciones: _onkeyUpSearchTransporte,
        comboBoxRefOpciones: comboBoxRefTransporte
    } = UseComboOpciones(props.isOpen);
    const {
        dataComboOpciones: dataComboVuelo,
        onClickComboOpciones: onClickComboVuelo,
        _onkeyUpSearchOpciones: _onkeyUpSearchVuelo,
        comboBoxRefOpciones: comboBoxRefVuelo
    } = UseComboOpciones(props.isOpen);
    const {
        dataComboOpciones: dataComboTtitular,
        onClickComboOpciones: onClickComboTtitular,
        _onkeyUpSearchOpciones: _onkeyUpSearchTtitular,
        comboBoxRefOpciones: comboBoxRefTtitular
    } = UseComboOpciones(props.isOpen);
    const {
        dataComboOpciones: dataComboTcontratista,
        onClickComboOpciones: onClickComboTcontratista,
        _onkeyUpSearchOpciones: _onkeyUpSearchTcontratista,
        comboBoxRefOpciones: comboBoxRefTcontratista
    } = UseComboOpciones(props.isOpen);

    /* Event */
    /* const _onChangeText = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event != undefined) {
            if (newValue != undefined) {
                let { name } = event?.target as HTMLInputElement;

                switch (name) {
                    case 'nombre':
                        setForm({
                            ...form,
                            nombre: newValue,
                        })
                        break;
                    case 'nombreCorto':
                        setForm({
                            ...form,
                            nombreCorto: newValue,
                        })
                        break;
                    default:
                        break;
                }
            }
        }
    } */

    const onChangeCombo = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, type?: string) => {
        if (event != undefined) {
            if (option != undefined) {
                switch (type) {
                    case 'titular':
                        setCommand({
                            ...command,
                            esTitular: option.key.toString() == 'true' ? true : false,
                        })
                        console.log(option.key.toString())
                        break;
                    case 'transportista':
                        setCommand({
                            ...command,
                            esTransportista: option.key.toString() == 'true' ? true : false,
                        })
                        break;
                    case 'vuelo':
                        setCommand({
                            ...command,
                            esVuelo: option.key.toString() == 'true' ? true : false,
                        })
                        break;
                    case 'tTitular':
                        setCommand({
                            ...command,
                            trasladoTitular: option.key.toString() == 'true' ? true : false,
                        })
                        break;
                    case 'tTransportista':
                        setCommand({
                            ...command,
                            trasladoContratista: option.key.toString() == 'true' ? true : false,
                        })
                        break;
                    default:
                        break;
                }
            }
        }
    }

    const onRenderHeader = useCallback(
        () => (
            <>
                <PanelHeader
                    // nameIconHeader="Edit"
                    textHeader={`Empresa`}
                    subTextHeader={`Actualizar empresa`}
                />
            </>
        ), []
    );

    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Actualizar"
                    // texto2={"Salir"}
                    disableButton={disableForm}
                    onClick={putEditarEmpresa}
                    onDismiss={reset}
                />
            </>
        ), [command, disableForm]
    );

    return (
        <>
            <Panel
                type={PanelType.medium}
                onRenderHeader={onRenderHeader}
                onRenderFooter={(!loading && mensaje == "") ? onRenderFooter : undefined}
                isFooterAtBottom
                isOpen={props.isOpen}
                onDismiss={reset}
            >
                <div className="ms-Grid" dir="ltr" style={{ padding: '0 1.5rem' }}>
                    <div hidden={mensaje == ""}>
                        <MessageBarResponse
                            objetoResponse={{ codigo: status, mensaje: mensaje }}
                            close={true}
                        />
                    </div>
                    <div hidden={!loading}>
                        <ProgressBarLoading></ProgressBarLoading>
                    </div>

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <TextField
                                name='nombre'
                                label='Nombre'
                                multiline
                                rows={3}
                                value={command.nombre ?? ''}
                                autoComplete='off'
                                // onChange={_onChangeText}
                                onChange={(event, newValue) => {
                                    if (newValue != undefined) {
                                        setCommand({
                                            ...command,
                                            nombre: newValue
                                        })
                                    }
                                }}
                            />
                        </div>
                    </div><br />

                    <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <TextField
                                name='nombreCorto'
                                value={command.nombreCorto ?? ''}
                                label='Nombre Corto'
                                autoComplete='off'
                                // onChange={_onChangeText}
                                onChange={(event, newValue) => {
                                    if (newValue != undefined) {
                                        setCommand({
                                            ...command,
                                            nombreCorto: newValue
                                        })
                                    }
                                }}
                            />
                        </div>
                    </div><br />

                    <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
                        <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                            <ComboBoxBase
                                title="Es Titular:"
                                componentRef={comboBoxRefTitular}
                                KeyUp={_onkeyUpSearchTitular}
                                onClick={onClickComboTitular}
                                options={dataComboTitular}
                                selectedKey={command.esTitular != null ? (command.esTitular ? 'true' : 'false') : undefined}
                                onChange={(e: React.FormEvent<IComboBox>, option) => {
                                    onChangeCombo(e, option, "titular");
                                }}
                            />
                        </div>

                        <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                            <ComboBoxBase
                                title="Es Transportista:"
                                componentRef={comboBoxRefTransporte}
                                KeyUp={_onkeyUpSearchTransporte}
                                onClick={onClickComboTransporte}
                                options={dataComboTransporte}
                                selectedKey={command.esTransportista != null ? (command.esTransportista ? 'true' : 'false') : undefined}
                                onChange={(e: React.FormEvent<IComboBox>, option) => {
                                    onChangeCombo(e, option, "transportista");
                                }}
                            />
                        </div>
                    </div><br />

                    {/* <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <ComboBoxBase
                                title="Es Transportista:"
                                componentRef={comboBoxRefTransporte}
                                KeyUp={_onkeyUpSearchTransporte}
                                onClick={onClickComboTransporte}
                                options={dataComboTransporte}
                                selectedKey={command.esTransportista != null ? (command.esTransportista ? 'true' : 'false') : undefined}
                                onChange={(e: React.FormEvent<IComboBox>, option) => {
                                    onChangeCombo(e, option, "transportista");
                                }}
                            />
                        </div>
                    </div><br /> */}

                    <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
                        <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                            <ComboBoxBase
                                title="transporta Titular:"
                                componentRef={comboBoxRefTtitular}
                                KeyUp={_onkeyUpSearchTtitular}
                                onClick={onClickComboTtitular}
                                options={dataComboTtitular}
                                selectedKey={command.trasladoTitular != null ? (command.trasladoTitular ? 'true' : 'false') : undefined}
                                onChange={(e: React.FormEvent<IComboBox>, option) => {
                                    onChangeCombo(e, option, "tTitular");
                                }}
                            />
                        </div>

                        <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                            <ComboBoxBase
                                title="Transporta Contratista:"
                                componentRef={comboBoxRefTcontratista}
                                KeyUp={_onkeyUpSearchTcontratista}
                                onClick={onClickComboTcontratista}
                                options={dataComboTcontratista}
                                selectedKey={command.trasladoContratista != null ? (command.trasladoContratista ? 'true' : 'false') : undefined}
                                onChange={(e: React.FormEvent<IComboBox>, option) => {
                                    onChangeCombo(e, option, "tTransportista");
                                }}
                            />
                        </div>
                    </div><br />

                    <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
                        <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                            <ComboBoxBase
                                title="Es Vuelo:"
                                componentRef={comboBoxRefVuelo}
                                KeyUp={_onkeyUpSearchVuelo}
                                onClick={onClickComboVuelo}
                                options={dataComboVuelo}
                                selectedKey={command.esVuelo != null ? (command.esVuelo ? 'true' : 'false') : undefined}
                                onChange={(e: React.FormEvent<IComboBox>, option) => {
                                    onChangeCombo(e, option, "vuelo");
                                }}
                            />
                        </div>
                    </div>

                    {/*  <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <ComboBoxBase
                                title="Transporta Contratista:"
                                componentRef={comboBoxRefTcontratista}
                                KeyUp={_onkeyUpSearchTcontratista}
                                onClick={onClickComboTcontratista}
                                options={dataComboTcontratista}
                                selectedKey={command.trasladoContratista != null ? (command.trasladoContratista ? 'true' : 'false') : undefined}
                                onChange={(e: React.FormEvent<IComboBox>, option) => {
                                    onChangeCombo(e, option, "tTransportista");
                                }}
                            />
                        </div>
                    </div> */}
                </div>
            </Panel>
        </>
    )
}